module.exports = {
    "entityName": "reference",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            "value": "name",
            "text": "Name",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            render: item => `${item.name} ${item.surname}`,
            "validators": [
                "required"
            ]
        },
        {
            "value": "surname",
            "text": "Surname",
            "type": "text",
            "validators": [
                "required"
            ]
        },
        {
            "value": "email",
            "text": "Email",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
                "email"
                //issue email 200 caratteri
                ,
                "emaillen"
                //issue email 200 caratteri
            ]
        },
        {
            "value": "phone",
            "text": "Phone",
            "type": "text",
            table: true,
            "validators": [
                "required"
            ]
        }
    ],
    "actions": ["remove"]
}